import type { CustomCellRendererProps } from "ag-grid-react";
import { TitleCellContainer } from "./styles";
import Title from "../Title";

interface TitleCellRendererProps extends CustomCellRendererProps {
  data: { id: number };
}

export const TitleCellRenderer = ({
  data,
}: TitleCellRendererProps): React.ReactElement => {
  return (
    <TitleCellContainer>
      <Title id={data.id} />
    </TitleCellContainer>
  );
};
